import { render, staticRenderFns } from "./SendLavReport.vue?vue&type=template&id=47c9d24d"
import script from "./SendLavReport.vue?vue&type=script&lang=js"
export * from "./SendLavReport.vue?vue&type=script&lang=js"
import style0 from "./SendLavReport.vue?vue&type=style&index=0&id=47c9d24d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports